export const ProductsMockData = [
  { id: 1, text: 'Document upload from multiple sources' },
  { id: 2, text: 'Document indexing with customizable fields' },
  { id: 3, text: 'Document encryption' },
  { id: 4, text: 'Invoicing' },
  { id: 5, text: 'Integration with E-Fakture' }
];
